<app-nav></app-nav>
<div class="container mt-2 mb-2 pt-5 pb-5">
    <div class="row ">
        <div class="col-5 border-right border-dark">
            <h1 [innerHTML]="'pricing.title' | translate"></h1>
            <p>{{'pricing.subtitle' | translate}}</p>
            <ul class="features">
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Take science-based tests for stress, burnout, and mood" | translate}}
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Chat with an AI trained in mental health" | translate}}
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Analyze your state with real-time eye-tracking" | translate}}
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Detect early signs of emotional strain before they escalate" | translate}}
                </li>
                <!--                <li>-->
                <!--                    <i class="bi bi-check-circle-fill"></i>-->
                <!--                    {{"pricing.See how attention patterns reflect your mental load" | translate}}-->
                <!--                </li>-->
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Get personalized, evidence-based recommendations" | translate}}

                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    {{"pricing.Stay fully private" | translate}}
                </li>
            </ul>
        </div>
        <div class="col-7 pt-4 pb-4 d-flex justify-content-end">
            <div class="pricing-wrapper">
                <h3 class="mb-4">
                    {{"pricing.Start Your Journey with Anima" | translate}}
                </h3>
                <div class="border border-primary pt-4 pb-4 pl-3 pr-3 mb-4">
                    <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                        <h3 class="">
                            {{"pricing.AI Companion Access" | translate}}
                        </h3>
                        <h3 class="highlight">$0</h3>
                    </div>
                    <p class="text-primary">
                        {{"pricing.Anima helps you understand your mental state in just minutes with personalized support from an  AI companion trained in neuroscience. You'll get daily insights to manage stress, anxiety, and  focus — plus access to advanced tests for burnout, depression, and emotional overload." | translate}}
                    </p>
                </div>
                <hr class="border-dark">
                <app-paypal *ngIf="lang.currentLang !== 'uk'"></app-paypal>
                <app-liqpay *ngIf="lang.currentLang === 'uk'"></app-liqpay>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
<lib-preloader [text]="'checking the payment status...'" [loading]="loading"></lib-preloader>
